/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

let $ = jQuery.noConflict();

$(document).ready(function($) {

    console.log('venn-diagram.js loaded');

    // on scroll, update the #venn-diagram --rotation style attribute
    $(window).scroll(function(){
        let scroll = $(window).scrollTop(),
            vennDiagram = $('#venn-diagram'),
            vennDiagramHeight = vennDiagram.outerHeight(),
            maxRotation = 180,
            rotation = 0,
            denominator = 20;

        rotation = scroll / denominator;

        vennDiagram.css('--rotation', rotation + 'deg');
    }).trigger('scroll');

    $('.trigger-c').bind('mouseover', function(){
        let id = $(this).attr('data-id'),
            $c = $('#' + id);

        $c.addClass('active');
    }).bind('mouseout', function(){
        let id = $(this).attr('data-id'),
            $c = $('#' + id);

        $c.removeClass('active');
    });

    $('.venn-diagram__copy__cs__c').bind('mouseover', function(){
        let id = $(this).attr('id'),
            $c = $('.trigger-c[data-id="' + id + '"]');

        $c.addClass('active');
    }).bind('mouseout', function(){
        let id = $(this).attr('id'),
            $c = $('.trigger-c[data-id="' + id + '"]');

        $c.removeClass('active');
    });

});

